module.exports = __webpack_public_path__ + "0a6b7c41ba185d6646e803adf9aa8c7e.png";